import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || "Unknown runtime error",
    };
  }

  componentDidCatch(error) {
    // Keep logging simple and local.
    console.error("AppErrorBoundary caught error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[50vh] items-center justify-center p-6">
          <div className="w-full max-w-md rounded-xl border bg-card p-6 text-center shadow-sm">
            <AlertTriangle className="mx-auto mb-3 h-8 w-8 text-amber-500" />
            <h2 className="text-lg font-semibold">Something went wrong</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Refresh to recover. If this keeps happening, try again in a minute.
            </p>
            {process.env.NODE_ENV !== "production" && this.state.errorMessage ? (
              <p className="mt-3 rounded-md bg-muted px-3 py-2 text-left text-xs text-muted-foreground">
                {this.state.errorMessage}
              </p>
            ) : null}
            <Button className="mt-4" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
